import React from 'react'
import './Divider.scss'

function Divider(props) {
    const { gutter, color } = props
    return (
        <div class={`divider ${props.className}`} style={{margin: `${gutter}px 0`, backgroundColor: color ? '#60697a' : '#e4e5e6'}} />
    )
}

export default Divider;
